import React from "react";

const ButtonBlockPreview = ({ block }) => {
    const buttons = block.props.buttons || [];
    const buttonCount = block.props.buttonCount || 1;
    const buttonPlacement = block.props.buttonPlacement || "horizontal";

    const visibleButtons = buttons.slice(0, buttonCount);

    const renderButton = (buttonData, index) => {
        const {
            text = "Button",
            link = "#",
            fontSize = "16",
            fontColor = "#000000",
            backgroundColor = "#2563eb",
            cornerRadius = "0",
            bold = false,
            italic = false,
            underline = false,
            addBorder = false,
            borderColor = "#000000",
            borderWeight = "0",
            marginTop = "0",
            marginRight = "0",
            marginBottom = "0",
            marginLeft = "0",
            alignment = "center"
        } = buttonData;

        const buttonStyle = {
            backgroundColor,
            color: fontColor,
            fontSize: `${fontSize}px`,
            fontWeight: bold ? "bold" : "normal",
            fontStyle: italic ? "italic" : "normal",
            textDecoration: underline ? "underline" : "none",
            border: addBorder ? `${borderWeight}px solid ${borderColor}` : "none",
            borderRadius: `${cornerRadius}px`,
            padding: "8px 16px",
            justifyContent: alignment,
            whiteSpace: "normal",
            height: "auto",
            marginTop: `${marginTop}px`,
            marginRight: `${marginRight}px`,
            marginBottom: `${marginBottom}px`,
            marginLeft: `${marginLeft}px`,
            display: buttonPlacement === "horizontal" ? "inline-block" : "block",
            width: buttonPlacement === "horizontal" ? "auto" : "100%",
        };

        return (
            <a key={index} href={link || "#"} style={{ textDecoration: "none" }}>
                <button style={buttonStyle}>{text}</button>
            </a>
        );
    };

    const containerStyle = {
        display: buttonPlacement === "horizontal" ? "flex" : "block",
        gap: "8px",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
        alignItems: buttonPlacement === "horizontal" ? "center" : "flex-start",
        // alignItems: "center",
    };

    return (
        <div style={containerStyle}>
            {visibleButtons.map((buttonData, index) => renderButton(buttonData, index))}
        </div>
    );
};

export default ButtonBlockPreview;
